

import React from 'react';
import DatePicker, { registerLocale } from "react-datepicker";
import Select from 'react-select'
import ControlledInput from './controlledInput';

import fr from 'date-fns/locale/fr';
import "react-datepicker/dist/react-datepicker.css";
import wait from './img/wait.svg';

registerLocale('fr', fr)

class SearchBar extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            users:[]
        }
    }

    componentDidMount() {
        if ( this.props.operator ) {
            this.props.api.post(
                {action:'list_users'},
                (res)=>{
                    this.setState({users:res.users})
                }
            )
        }
    }

    makeUserOptions() {
        return [ {'value':'-','label':'Non affecté'}, ... this.state.users.map( user => ({'value':user.login,'label':user.login}) )]
    }

    render() {
        return this.props.quotations ? <div className="search_bar">
                <div className="search_column">
                    <span className="left_title">Filtres</span>
                </div>
                <div className="search_column right_search_column">
                    <div className="search_entry"><label>Créé après</label><div className="date_picker"><DatePicker dateFormat="dd/MM/yyyy" isClearable showYearDropdown locale="fr" selected={this.props.startDate} onChange={this.props.app.setStartDate.bind(this.props.app)} /></div></div>
                    <div className="search_entry"><label>et/ou avant</label><div className="date_picker"><DatePicker dateFormat="dd/MM/yyyy" isClearable showYearDropdown locale="fr" selected={this.props.endDate} onChange={this.props.app.setEndDate.bind(this.props.app)} /></div></div>
                    <Select placeholder="Apporteur" isMulti options={SearchBar.optionsApporteur} value={this.props.searchApporteur} onChange={this.props.app.setSearchApporteur.bind(this.props.app)}/>
                </div>
            </div> : <div className="search_bar">
            <div className="search_column">
                <span className="left_title">Filtres</span>
                <Select placeholder="Status" isMulti options={SearchBar.optionsStatusProcess} value={this.props.searchStatusProcess} onChange={this.props.app.setSearchStatusProcess.bind(this.props.app)}/>
                <Select placeholder="Status de traitement" isMulti options={SearchBar.optionsStatus} value={this.props.searchStatus} onChange={this.props.app.setSearchStatus.bind(this.props.app)}/>
                <div className="search_entry"><label>Mes devis uniquement <input type="checkbox" checked={this.props.searchSelf} onChange={this.props.app.setSearchSelf.bind(this.props.app)}/></label></div>
                <div className="search_entry"><label>Devis en attente <input type="checkbox" checked={this.props.searchUnvalidated} onChange={this.props.app.setSearchUnvalidated.bind(this.props.app)}/></label></div>
                {this.props.operator ? <div className="search_entry"><label>Masquer Sollyazar <input type="checkbox" checked={this.props.searchNoSolly} onChange={this.props.app.setSearchNoSolly.bind(this.props.app)}/></label></div> : <></>}
                {this.props.operator ? <Select placeholder="Commercial" isMulti options={this.makeUserOptions()} value={this.props.searchUser.map(login=>( (login=='-')?{value:'-',label:'Non affecté'}:{value:login,label:login}))} onChange={this.props.app.setSearchUser.bind(this.props.app)}/> : <></>}
                {this.props.operator ? <Select placeholder="Apporteur" isMulti options={SearchBar.optionsApporteur} value={this.props.searchApporteur} onChange={this.props.app.setSearchApporteur.bind(this.props.app)}/> : <></>}
                {this.props.loading ? <img src={wait} className="wait_img"/> : ''}
            </div>
            <div className="search_column right_search_column">
                <div className="barbox">
                    <label>Date de création</label>
                    <div className="search_entry"><label>du</label><div className="date_picker"><DatePicker dateFormat="dd/MM/yyyy" isClearable showYearDropdown locale="fr" selected={this.props.startDate} onChange={this.props.app.setStartDate.bind(this.props.app)} /></div></div>
                    <div className="search_entry"><label>au</label><div className="date_picker"><DatePicker dateFormat="dd/MM/yyyy" isClearable showYearDropdown locale="fr" selected={this.props.endDate} onChange={this.props.app.setEndDate.bind(this.props.app)} /></div></div>
                    <label>Dernière modification</label>
                    <div className="search_entry"><label>du</label><div className="date_picker"><DatePicker dateFormat="dd/MM/yyyy" isClearable showYearDropdown locale="fr" selected={this.props.startDateModif} onChange={this.props.app.setStartDateModif.bind(this.props.app)} /></div></div>
                    <div className="search_entry"><label>au</label><div className="date_picker"><DatePicker dateFormat="dd/MM/yyyy" isClearable showYearDropdown locale="fr" selected={this.props.endDateModif} onChange={this.props.app.setEndDateModif.bind(this.props.app)} /></div></div>
                    
                </div>
                <div className="search_entry"><label>Nom</label>
                <ControlledInput type="text" property="searchName" originProperty="filterName" container={this.props.app}
                    onSubmit={this.props.app.onFilter.bind(this.props.app)}
                    withSaveButton withClearButton
                    />
                </div>
                <div className="search_entry"><label>Téléphone</label>
                <ControlledInput type="text" property="searchTelephone" originProperty="filterTelephone" container={this.props.app}
                    onSubmit={this.props.app.onFilter.bind(this.props.app)}
                    withSaveButton withClearButton
                    />
                </div>
                
                <div className="count">
                    {( this.props.count && !this.props.loading ) ? ''+this.props.count+' devis':''}
                    <button onClick={this.props.container.exportCsv.bind(this.props.container)}>Export CSV</button>
                </div>
            </div>
        </div>
    }
}

SearchBar.optionsApporteur = [
    { value: 'lesfurets', label: 'Les furets' },
    { value: 'lelynx', label: 'Le Lynx' },
    { value: 'solly', label: 'Solly Azar'},
    { value: 'assurland', label: 'Assurland'},
    { value: 'assurland-test', label: 'Assurland Test'}
]

SearchBar.optionsStatusProcess = [
    { value: 'ongoing', label: 'En cours' },
    { value: 'paid_unsubsribed', label: 'Acompte payé' },
    { value: 'paid_subscribed', label: 'Souscrit et acompte payé'},
    { value: 'subscribed_solly', label: 'Souscrit sur SollyAzar' },
    { value: 'subscribing', label: 'Souscription en cours ...' },
    { value: 'subscribe_error', label: 'Erreur à la souscription, demande xenassur créée' },
    { value: 'presubscribe_error', label: 'Erreur à la souscription, demande xenassur non créée' },
    { value: 'cancelled', label: 'Annulé' }
]

SearchBar.statusProcessToLabel = (status_process)=>{ 
    const option = SearchBar.optionsStatusProcess.find(option=>{return option.value==status_process})
    return option ? option.label : '??'
}


SearchBar.optionsStatus = [
    { value: 'Non traité', label:'Non traité'},
    { value: 'Répondeur', label:'Répondeur'},
    { value: 'Répondeur 2', label:'Répondeur 2'},
    { value: 'Répondeur 3', label:'Répondeur 3'},
    { value: 'Répondeur 4', label:'Répondeur 4'},
    { value: 'En cours de traitement', label:'En cours de traitement'},
    { value: 'En attente de retour', label:'En attente de retour'},
    { value: 'Traité', label:'Traité'},
    { value: 'Intéressé à recontacter', label:'Intéressé à recontacter'},
    { value: 'A recontacter', label:'A recontacter'},
    { value: 'Intéréssé nous recontacte', label:'Intéréssé nous recontacte'},
    { value: 'Paiement de l\'accompte validé', label:'Paiement de l\'accompte validé'},
    { value: 'Pas intéressé', label:'Pas intéressé'},
    { value: 'Déjà assuré concurrence', label:'Déjà assuré concurrence'},
    { value: 'Faux numéro / injoignable', label:'Faux numéro / injoignable'},
    { value: 'Devis test', label:'Devis test'},
    { value: 'Doublon', label:'Doublon'},
    { value: 'Hors cible', label:'Hors cible'}
]


export default SearchBar;